import { render } from "./RequirementDescription.vue?vue&type=template&id=6c8e710a&scoped=true"
import script from "./RequirementDescription.vue?vue&type=script&lang=js"
export * from "./RequirementDescription.vue?vue&type=script&lang=js"

import "./RequirementDescription.vue?vue&type=style&index=0&id=6c8e710a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8e710a"]])

export default __exports__